// extracted by mini-css-extract-plugin
export default {"zoomControls":"Paa-z","zoomControlButton":"Qaa-z","zoomBanner":"Raa-z","bannerButton":"Saa-z","imageButton":"Taa-z","zoom":"Uaa-z","zoomContent":"Vaa-z"};